const toNumericValue = value => {
  if (typeof value === "number" && Number.isFinite(value)) return value

  const raw = String(value ?? "")
    .trim()
    .replace(/\s/g, "")
    .replace(/\.(?=\d{3}(?:\D|$))/g, "")
    .replace(",", ".")
    .replace(/[^\d.-]/g, "")

  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : 0
}

export const formatChartNumber = (value, maxFractionDigits = 2) => {
  const numericValue = toNumericValue(value)
  const rounded = numericValue.toFixed(maxFractionDigits)
  const [integerPartRaw, decimalPartRaw = ""] = rounded.split(".")
  const integerPart = integerPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ".")

  if (maxFractionDigits === 0) return integerPart

  const decimalPart = decimalPartRaw.replace(/0+$/, "")
  return decimalPart ? `${integerPart},${decimalPart}` : integerPart
}
